import React, { useEffect } from 'react'
import TechnicalExpertiseMainBlock from '../../components/TechnicalExpertiseMainBlock/TechnicalExpertiseMainBlock'
import TechnicalExpertisePreviewBlock from '../../components/TechnicalExpertisePreviewBlock/TechnicalExpertisePreviewBlock'
import WhyDMPImportant from '../../components/WhyDMPImportant/WhyDMPImportant'
import DiagramTabs from '../../components/DiagramTabs/DiagramTabs'
import ContactUs from '../../components/ContactUs/ContactUs'
import mainDiagramDM from './../../components/TechnicalExpertiseMainBlock/Frame 10.png'

import resourcesForDark from './../../components/WhyDMPImportant/efficientPink.svg'
import resourcesForLight from './../../components/WhyDMPImportant/efficientBlue.svg'
import secureForDark from './../../components/WhyDMPImportant/securePink.svg'
import secureForLight from './../../components/WhyDMPImportant/secureBlue.svg'
import valuableForDark from './../../components/WhyDMPImportant/diamondPink.svg'
import valuableForLight from './../../components/WhyDMPImportant/diamondBlue.svg'

import governanceDiagram from './../../components/DiagramTabs/governanceDiagram.png'
import designDiagram from './../../components/DiagramTabs/designDiagram.png'
import lineageDiagram from './../../components/DiagramTabs/lineageDiagram.png'
import qualityDiagram from './../../components/DiagramTabs/qualityDiagram.png'
import strategyDiagram from './../../components/DiagramTabs/strategyDiagram.png'

export default function TechnicalExpertiseDataManagement() {

  const dataManagementContent = {
    technicalExpertisePrivewBlock: {
      firstTitle: 'Data Management',
      secondTitle: 'Consultancy Services',
      bottomText: 'A team of experts ready to help to discover and understand business value of data'
    },
    technicalExpertiseMainBlock: {
      title: 'We help our customers understand the business value that data products bring to them',
      imageSource: mainDiagramDM
    },
    whyImportant: {
      mainTitle: 'Data Management',
      imgSrc1Dark: resourcesForDark,
      imgSrc1Light: resourcesForLight,
      title1: 'Efficient Use Of Resources',
      desc1: 'A data management partner is important because they help an organization optimize the use of its data by providing strategies and tools to maximize efficiency in storing, processing, and analyzing it',
      imgSrc2Dark: secureForDark,
      imgSrc2Light: secureForLight,
      title2: 'Ensuring Safety',
      desc2: 'The data management partner plays a key role in ensuring data security and compliance with regulatory standards, which is especially important in today\'s environment with increased attention to privacy and regulations',
      imgSrc3Dark: valuableForDark,
      imgSrc3Light: valuableForLight,
      title3: 'Maximizing The Value Of Data',
      desc3: 'Data management partnerships help maximize the business value of data by helping an organization extract valuable information, make informed decisions, and better meet customer and market needs',
    },
    diagramTabs: {
      data: [
        {
          label: "Data Governance",
          value: "governance",
          imageSource: governanceDiagram,
          desc: `We assist clients in establishing robust data governance frameworks, defining policies, roles, and responsibilities to ensure data integrity, security, and compliance. By implementing governance best practices, organizations can maintain data quality, enhance decision-making processes, and build trust in their data assets.`,
        },
        {
          label: "Data Quality Assessment",
          value: "quality",
          imageSource: qualityDiagram,
          desc: `In this category, we conduct thorough assessments to evaluate the quality of data assets. Our team employs industry-standard methodologies to identify and rectify data inconsistencies, inaccuracies, and completeness issues, ensuring that organizations can rely on high-quality data for informed decision-making.`,
        },

        {
          label: "Data Lineage",
          value: "lineage",
          imageSource: lineageDiagram,
          desc: `We offer solutions for tracking the lineage of data, providing insights into its origin, transformations, and movements across systems. Understanding data lineage is crucial for maintaining transparency, traceability, and compliance, enabling organizations to have a clear picture of how data flows through their processes.`,
        },

        {
          label: "Data Strategy",
          value: "strategy",
          imageSource: strategyDiagram,
          desc: `In this group, we focus on helping organizations develop comprehensive data strategies, ensuring alignment with their overall business objectives. This involves defining clear goals, identifying data sources, and establishing a roadmap for effective data utilization.`,
        },

        {
          label: "Data Design",
          value: "design",
          imageSource: designDiagram,
          desc: `Within this group, our emphasis is on crafting well-structured and efficient data designs. We collaborate with clients to create scalable databases, intuitive information architectures, and user-friendly interfaces, ensuring that the data is not only accessible but also optimized for performance and usability.`,
        },
      ]
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  return (
    <div>
      <TechnicalExpertisePreviewBlock technicalExpertisePrivewBlock={dataManagementContent.technicalExpertisePrivewBlock} />
      <TechnicalExpertiseMainBlock technicalExpertiseMainBlock={dataManagementContent.technicalExpertiseMainBlock} />
      <WhyDMPImportant whyImportant={dataManagementContent.whyImportant} />
      <DiagramTabs diagramTabs={dataManagementContent.diagramTabs} />
      <ContactUs />
    </div>
  )
}
